import { render, staticRenderFns } from "./InterstitialLayout.vue?vue&type=template&id=0244522c&scoped=true&"
import script from "./InterstitialLayout.vue?vue&type=script&lang=js&"
export * from "./InterstitialLayout.vue?vue&type=script&lang=js&"
import style0 from "./InterstitialLayout.vue?vue&type=style&index=0&id=0244522c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0244522c",
  null
  
)

export default component.exports